// Import polyfills FIRST before any other imports to ensure process is available
import './polyfills';

import ReactDOM from 'react-dom';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { MemberProvider } from './shared/contexts/memberContext';
import { ChatProvider } from './shared/contexts/chatContext';
import './i18n';

ReactDOM.render(
    <MemberProvider>
        <ChatProvider>
            <App />
        </ChatProvider>
    </MemberProvider>,
    document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

// Handle unhandled promise rejections - ignore ECONNRESET errors
window.addEventListener('unhandledrejection', event => {
    // Ignore ECONNRESET errors - these are expected when connections are closed
    const error = event.reason;
    if (
        error &&
        ((error.message &&
            (error.message.includes('ECONNRESET') ||
                error.message.includes('socket hang up') ||
                error.message.includes('Connection closed') ||
                error.message.includes('read ECONNRESET'))) ||
            error.code === 'ECONNRESET' ||
            (typeof error === 'string' &&
                (error.includes('ECONNRESET') ||
                    error.includes('socket hang up') ||
                    error.includes('Connection closed'))))
    ) {
        console.log('Ignoring expected connection reset error:', error.message || error);
        event.preventDefault(); // Prevent error from appearing in console
        return;
    }
    // Let other errors through for debugging
});
